import api from './api';

export interface OrderItem {
  id: number;
  product: {
    id: number;
    name: string;
    image: string | null;
  };
  product_variant?: {
    id: number;
    name: string | null;        // Ej: "Color", "Talla"
    color_hex: string | null;   // Ej: "#FF0000"
    sku: string | null;
    image: string | null;
  } | null;
  quantity: number;
  unit_price: number;
  total_price: number;
  stock_location?: string;
  stock_location_display?: string;
}

export interface Order {
  id: string;
  user: number | null;
  status: 'pending' | 'processing' | 'shipped' | 'delivered' | 'cancelled';
  total_amount: number;
  total_price: number; // Alias for total_amount
  items_count: number;
  customer_name?: string | null;
  email: string | null;
  phone: string | null;
  shipping_address?: string | null;
  shipping_region?: string | null;
  shipping_cost?: number;
  created_at: string;
  public_code?: string;
  order_code?: string; // Alias for public_code
  items?: OrderItem[];
  is_deleted?: boolean;
  deleted_at?: string | null;
}

export const orderService = {
  getAll: async (): Promise<Order[]> => {
    console.log('[orderService] Obteniendo TODAS las órdenes sin paginación...');
    
    try {
      // Usar parámetro no_page=true para obtener todos los resultados (staff only)
      const response = await api.get('orders/orders/?no_page=true');
      const data = response.data;
      
      console.log('[orderService] Response status:', response.status);
      
      if (data == null) {
        console.log('[orderService] Data is null, retornando []');
        return [];
      }
      
      // Si es un array directo (sin paginación activada en backend)
      if (Array.isArray(data)) {
        console.log(`[orderService] ✅ Array directo - Total órdenes: ${data.length}`);
        return data as Order[];
      }
      
      // Si viene con estructura de paginación pero el backend devolvió todo
      if (data.results && Array.isArray(data.results)) {
        console.log(`[orderService] ✅ Con results - Total órdenes: ${data.results.length}`);
        
        // Advertir si aún hay paginación (no debería pasar con no_page=true)
        if (data.next) {
          console.warn('[orderService] ⚠️ ADVERTENCIA: Aún hay paginación activa con no_page=true');
        }
        
        return data.results as Order[];
      }
      
      // Caso edge: data único
      console.log('[orderService] Data único, convirtiendo a array');
      return [data] as Order[];
      
    } catch (error) {
      console.error('[orderService] ❌ Error obteniendo órdenes:', error);
      throw error;
    }
  },

  getById: async (id: string): Promise<Order> => {
    const response = await api.get(`orders/orders/${id}/`);
    return response.data;
  },
  
  updateStatus: async (id: string, status: string): Promise<Order> => {
    try {
      const response = await api.patch(`orders/orders/${id}/`, { status });
      return response.data as Order;
    } catch (e) {
      console.error('[orderService] Error updating status:', e);
      throw e;
    }
  },
  delete: async (id: string): Promise<void> => {
    try {
      await api.delete(`orders/orders/${id}/`);
    } catch (e) {
      console.error('[orderService] Error deleting order:', e);
      throw e;
    }
  },

  getDeleted: async (): Promise<Order[]> => {
    console.log('[orderService] Obteniendo órdenes eliminadas (papelera)...');
    try {
      const response = await api.get('orders/orders/deleted/?no_page=true');
      const data = response.data;
      
      if (Array.isArray(data)) {
        console.log(`[orderService] ✅ Papelera - Total órdenes: ${data.length}`);
        return data as Order[];
      }
      
      if (data.results && Array.isArray(data.results)) {
        console.log(`[orderService] ✅ Papelera - Total órdenes: ${data.results.length}`);
        return data.results as Order[];
      }
      
      return [];
    } catch (error) {
      console.error('[orderService] ❌ Error obteniendo papelera:', error);
      throw error;
    }
  },

  restore: async (id: string): Promise<void> => {
    try {
      await api.post(`orders/orders/${id}/restore/`);
      console.log('[orderService] Orden restaurada:', id);
    } catch (e) {
      console.error('[orderService] Error restoring order:', e);
      throw e;
    }
  },

  emptyTrash: async (): Promise<void> => {
    try {
      await api.post('orders/orders/empty-trash/');
      console.log('[orderService] Papelera vaciada');
    } catch (e) {
      console.error('[orderService] Error emptying trash:', e);
      throw e;
    }
  }
};
